import DownloadStatisticsContainer from './containers/DownloadStatisticsContainer'

export default DownloadStatisticsContainer
